module.exports = __webpack_public_path__ + "img/support.b9ea714a.png";